var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiHighFiber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#e3fb94",
    opacity: 0.5,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.42 13.84c1.115-3.316 4.229-5.912 7.819-5.912C9.519 9.16 6.717 13.303 6.717 18H8.22s-.228-1.425.169-3.063c3.185.427 4.795.176 6.263-2.953.582-1.24 1.242-2.646 3.158-3.732a.372.372 0 00.04-.622c-4.49-3.356-13.95-1.647-11.432 6.21z",
    fill: "#31544e",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--high-fiber-affe047f409c3281c179243b6d96672d.svg";
export { SvgIconUiHighFiber as Component };